//import {HomePage} from  "./pages/homePage";
import { HomePage } from "./pagges/homePage";

function App() {
  return (
    
   
   <HomePage />
  );
}

export default App;
